"use client";

import { Typography } from "@repo/components";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Image from "next/image";
import Link from "next/link";
export default function RichBlockRenderer({
  content
}) {
  if (!content) return null;
  return <BlocksRenderer content={content} blocks={{
    paragraph: ({
      children
    }) => <Typography variant="paragraph">{children}</Typography>,
    heading: ({
      children,
      level
    }) => {
      switch (level) {
        case 1:
          return <Typography variant="h1">{children}</Typography>;
        case 2:
          return <Typography variant="h2">{children}</Typography>;
        case 3:
          return <Typography variant="h3">{children}</Typography>;
        case 4:
          return <Typography variant="h4">{children}</Typography>;
        case 5:
          return <Typography variant="h5">{children}</Typography>;
        default:
          return <Typography variant="h1">{children}</Typography>;
      }
    },
    image: ({
      image
    }) => {
      return <Image src={image.url} width={image.width} height={image.height} alt={image.alternativeText || ""} />;
    },
    link: ({
      children,
      url
    }) => <Link href={url} className="text-blue-500 hover:text-blue-400 hover:underline">
            {children}
          </Link>,
    list: ({
      children,
      format
    }) => {
      if (format === "unordered") {
        return <ul className="list-disc ps-6">{children}</ul>;
      } else if (format === "ordered") {
        return <ol className="list-decimal ps-6">{children}</ol>;
      }
    }
  }} data-sentry-element="BlocksRenderer" data-sentry-component="RichBlockRenderer" data-sentry-source-file="RichBlockRenderer.jsx" />;
}